import React, { useState } from "react";
import { serverResponse } from "../../../util/fakeServer";
import BrandModal from "./components/Brand.modal";
import GalleryModal from "./components/Gallery.modal";
import TextModal from "./components/Text.modal";
import TitleModal from "./components/Title.modal";
import PriceModal from "./components/Price.modal";
import AddCart from "./components/AddCart.modal";
import ReadMore from "../../common/ReadMore";
import VarietiesModal from "./components/Varieties.modal";
import Related from "./components/Related.modal";
import { connect } from "react-redux";

const PlusBody = ({ modalRedux }) => {
  const { dynamicContent: info } = modalRedux;

  const [varietySelected, setVarietySelected] = useState("");

  const stockLabel = info.stock === 'n' ? 'NON DISPONIBILE' : (info.stock === 'c' ? 'IN ARRIVO' : 'DISPONIBILE');
  const stockCircle = info.stock === 'n' ? 'not-available' : (info.stock === 'c' ? 'incoming' : 'available');
  const tdcLabel = info.tdc > 0 ? `Consegna entro ${info.tdc} giorni` : null

  return (
    <>

      {/* Brand logo */}
      {info.brand && (
        <BrandModal
          brand={info.brand}
          brand_logo={info.brand_logo}
          line={info.line}
        />
      )}

      {/* Galleria immagini */}

      <div className="col-12 col-lg-6" style={{ position: "relative" }}>
        <GalleryModal gallery={info.images} />
      </div>

      <div className="col-12 col-lg-6">
        {/* field1 */}
        <TitleModal title={info.field1} />

        {/* field2 */}
        <TextModal text1={info.field2} varieties={info.varieties} />

        {/* field 3 field4 */}
        {(!info.brand_logo ||
          info.brand_logo === undefined ||
          info.brand_logo === null) && (
            <TextModal text1={info.field3} text2={info.field4} />
          )}

        {/* Prezzo */}
        {/* <div className="row">
          <div className="col-12">
            <p style={{color: "green", fontWeight: "bold"}}>{tdcLabel}</p>
          </div>
        </div> */}
        <div className="row mt-3">
          <PriceModal
            skul={info.skul}
            strike_price={info.strike_price}
            price={info.price}
            prices={info.prices ? info.prices : []}
            offer_price={info.offer_price}
            discount_rate={info.discount_rate}
            price_label={info.price_label}
            stockLabel={stockLabel}
            stockCircle={stockCircle}
            tdcLabel={tdcLabel}
            tdc={+info.tdc}
          />
        </div>

        {/* Descrizione estesa */}
        {info.descrizione_estesa !== undefined &&
          info.descrizione_estesa !== "" &&
          info.descrizione_estesa !== null && (
            <div className="row">
              <div className="col-12 wrapText">
                <ReadMore>{info.descrizione_estesa}</ReadMore>
              </div>
            </div>
          )}

        {/* Varietà */}
        {info.varieties.length > 0 && (
          <VarietiesModal
            varieties={info.varieties}
            handleChangeVariety={setVarietySelected}
          />
        )}

        {/* Aggiunta al carrello */}
        {!serverResponse.config.hide_grocery_list && (
          <AddCart
            setVarietySelected={setVarietySelected}
            varietySelected={varietySelected}
            info={info}
          />
        )}
      </div>
      <div className="col-12">
        {/* Prodotti correlati */}
        {info.related.length > 0 && <Related related={info.related} />}
      </div>
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    modalRedux: state.modal
  };
};

export default connect(mapStateToProps)(PlusBody);
